import React from "react";
import { getMessage } from "../data/locales";

const PasswordRequirements = () => (
  <div className="password-requirements">
    {getMessage("passwordPolicy.heading")}
    <ul>
      <li>{getMessage("passwordPolicy.minLength")}</li>
      <li>{getMessage("passwordPolicy.mixedCase")}</li>
      <li>{getMessage("passwordPolicy.number")}</li>
      <li>{getMessage("passwordPolicy.special")}</li>
    </ul>
  </div>
);

export default PasswordRequirements;
